"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Actions;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require("../../Button");

var _Button2 = _interopRequireDefault(_Button);

var _ActionMenu = require("../../ActionMenu");

var _ActionMenu2 = _interopRequireDefault(_ActionMenu);

var _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ACTION_MARGIN = 'mr4';

function Actions(_ref) {
  var children = _ref.children;
  var className = (0, _classnames2.default)('flex flex-row', _constants.ORDER_CLASSNAMES.BULK_CHILD.ACTIONS);
  return _react2.default.createElement("div", {
    className: className
  }, children);
}

Actions.Primary = Primary;
Actions.Secondary = Secondary;

function Primary(_ref2) {
  var label = _ref2.label,
      onClick = _ref2.onClick;
  var className = (0, _classnames2.default)(ACTION_MARGIN, _constants.ORDER_CLASSNAMES.BULK_CHILD.ACTIONS_CHILD.PRIMARY);
  return _react2.default.createElement("div", {
    className: className
  }, _react2.default.createElement(_Button2.default, {
    variation: "secondary",
    size: "small",
    onClick: onClick
  }, label));
}

function Secondary(_ref3) {
  var label = _ref3.label,
      actions = _ref3.actions,
      onActionClick = _ref3.onActionClick;
  var className = (0, _classnames2.default)(ACTION_MARGIN, _constants.ORDER_CLASSNAMES.BULK_CHILD.ACTIONS_CHILD.SECONDARY);
  return _react2.default.createElement("div", {
    className: className
  }, _react2.default.createElement(_ActionMenu2.default, {
    label: label,
    buttonProps: {
      variation: 'secondary',
      size: 'small'
    },
    options: actions.map(function (el) {
      return {
        label: el.label,
        onClick: function onClick() {
          return onActionClick(el);
        },
        isDangerous: el.isDangerous
      };
    })
  }));
}